/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountEnabledFeaturesQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountEnabledFeaturesQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly features: ReadonlyArray<{ readonly __typename?: 'AccountFeatureState', readonly feature: GraphQL.AccountFeature, readonly id: CK.ID }> } | null };


export const AccountEnabledFeaturesDocument = gql`
    query AccountEnabledFeatures($accountId: AccountId!) {
  account(id: $accountId) {
    id
    features {
      feature
      id
    }
  }
}
    `;

/**
 * __useAccountEnabledFeaturesQuery__
 *
 * To run a query within a React component, call `useAccountEnabledFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountEnabledFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountEnabledFeaturesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountEnabledFeaturesQuery(baseOptions: Apollo.QueryHookOptions<AccountEnabledFeaturesQuery, AccountEnabledFeaturesQueryVariables> & ({ variables: AccountEnabledFeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountEnabledFeaturesQuery, AccountEnabledFeaturesQueryVariables>(AccountEnabledFeaturesDocument, options);
      }
export function useAccountEnabledFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountEnabledFeaturesQuery, AccountEnabledFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountEnabledFeaturesQuery, AccountEnabledFeaturesQueryVariables>(AccountEnabledFeaturesDocument, options);
        }
export function useAccountEnabledFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountEnabledFeaturesQuery, AccountEnabledFeaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountEnabledFeaturesQuery, AccountEnabledFeaturesQueryVariables>(AccountEnabledFeaturesDocument, options);
        }
export type AccountEnabledFeaturesQueryHookResult = ReturnType<typeof useAccountEnabledFeaturesQuery>;
export type AccountEnabledFeaturesLazyQueryHookResult = ReturnType<typeof useAccountEnabledFeaturesLazyQuery>;
export type AccountEnabledFeaturesSuspenseQueryHookResult = ReturnType<typeof useAccountEnabledFeaturesSuspenseQuery>;
export type AccountEnabledFeaturesQueryResult = Apollo.QueryResult<AccountEnabledFeaturesQuery, AccountEnabledFeaturesQueryVariables>;